<template>
  <div>
    <!-- 제목 -->
    <v-sheet outlined class="d-flex align-center ma-2 px-4" height="60">
      <font class="font-weight-bold text-h6 grey--text text--darken-2">지점 관리</font>
    </v-sheet>

    <!-- 본문 -->
    <v-sheet outlined class="pa-2 ma-2">
      <v-radio-group v-model="selected" hide-details>
        <v-data-table
          :items="list"
          :loading="loading"
          hide-default-header
          no-data-text="등록된 지점이 없습니다."
          :footer-props="{
            'items-per-page-options': [10, 20, 100, -1],
            itemsPerPageText: '페이지당 지점 수',
          }"
        >
          <template v-slot:header>
            <tr>
              <th style="width: 52px"></th>
              <th style="width: 140px">지점 코드</th>
              <th style="width: 200px">지점명</th>
              <th style="width: 120px">상태</th>
              <th style="width: 220px">운영 상품</th>
              <th>설명</th>
              <th style="width: 200px">업데이트</th>
            </tr>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td>
                <v-radio class="ml-1" hide-details dense :value="item.id" @change="onSelect(item)"></v-radio>
              </td>
              <td class="text-truncate font-weight-medium">
                {{ item.branchCode }}
              </td>
              <td class="text-truncate">
                {{ item.name }}
              </td>
              <td>
                <v-chip
                  x-small
                  :color="item.status === 'ACTIVE' ? 'green lighten-2' : 'grey lighten-1'"
                  class="font-weight-bold"
                >
                  {{ item.status === "ACTIVE" ? "운영" : "비활성" }}
                </v-chip>
              </td>
              <td class="text-truncate">
                {{ formatProducts(item.availableProducts) }}
              </td>
              <td class="text-truncate">
                {{ item.description || "-" }}
              </td>
              <td class="text-truncate">
                {{ formatDate(item.updatedAt || item.createdAt) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-radio-group>

      <!-- 버튼 -->
      <v-sheet class="d-flex justify-end mt-2 pa-2" outlined>
        <v-btn class="px-6 ml-3" color="orange" large dark depressed @click="openUpdate">
          <v-icon small left>mdi-circle-edit-outline</v-icon>
          수정
        </v-btn>
        <v-btn class="px-6 ml-3" color="blue" large dark depressed @click="createItem">
          <v-icon small left>mdi-shape-circle-plus</v-icon>
          추가
        </v-btn>
        <v-btn class="px-6 ml-3" color="red" large dark depressed @click="deleteItem">
          <v-icon small left>mdi-close-circle-outline</v-icon>
          삭제
        </v-btn>
      </v-sheet>
    </v-sheet>

    <!-- 수정 -->
    <v-dialog v-model="dialog.update" width="540" content-class="rounded-xl">
      <Update :selectedItem="selectedItem" @close="dialog.update = false" @updated="onUpdated" :key="componentKey" />
    </v-dialog>

    <!-- 추가 -->
    <v-dialog v-model="dialog.insert" width="540" content-class="rounded-xl">
      <Insert @close="dialog.insert = false" @inserted="onInserted" :key="componentCreateKey" />
    </v-dialog>
  </div>
</template>

<script>
import Insert from "./Insert"
import Update from "./Update"

export default {
  components: { Insert, Update },

  data: () => ({
    list: [],
    loading: false,
    selected: null,
    selectedItem: {},
    dialog: {
      update: false,
      insert: false,
    },
    componentKey: 0,
    componentCreateKey: 0,
  }),

  mounted() {
    this.load()
  },

  methods: {
    async load() {
      this.loading = true
      try {
        const { data } = await this.$http.get("/api/admin/branch")
        this.list = data?.branches || []
      } catch (error) {
        console.error("branch load error", error)
        alert("지점 목록을 불러오는 중 오류가 발생했습니다.")
      } finally {
        this.loading = false
      }
    },
    onSelect(item) {
      this.selectedItem = item
      this.componentKey += 1
    },
    createItem() {
      this.componentCreateKey += 1
      this.dialog.insert = true
    },
    openUpdate() {
      if (!this.selectedItem?.id) {
        alert("수정할 지점을 선택해주세요.")
        return
      }
      this.dialog.update = true
    },
    async deleteItem() {
      if (!this.selectedItem?.id) {
        alert("삭제할 지점을 선택해주세요.")
        return
      }
      if (!confirm(`[${this.selectedItem.name}] 지점을 삭제하시겠습니까?`)) {
        return
      }
      try {
        await this.$http.delete(`/api/admin/branch/${this.selectedItem.id}`)
        alert("지점을 삭제했습니다.")
        this.selected = null
        this.selectedItem = {}
        this.load()
      } catch (error) {
        console.error("branch delete error", error)
        alert(error?.response?.data?.message || "지점을 삭제하는 중 오류가 발생했습니다.")
      }
    },
    onInserted() {
      this.dialog.insert = false
      this.load()
    },
    onUpdated() {
      this.dialog.update = false
      this.load()
    },
    formatProducts(products) {
      if (!Array.isArray(products) || products.length === 0) return "-"
      return products
        .map((code) => {
          if (code === "makershot") return "메이커샷"
          if (code === "premium") return "프리미엄"
          return code
        })
        .join(", ")
    },
    formatDate(date) {
      if (!date) return "-"
      return new Date(date).toLocaleString()
    },
  },
}
</script>
